import {
  ActionType,
  createReducer,
  createStandardAction,
  StateType
} from "typesafe-actions";
import { GeoBox } from "generated/graphql";

interface CenterActionPayload {
  latitude: number;
  longitude: number;
}

interface ViewActionPayload {
  latitude: number;
  longitude: number;
  zoom: number;
  bounds?: GeoBox;
}

export type MapActionType =
  | "CHANGE_CENTER"
  | "CHANGE_ZOOM"
  | "CHANGE_VIEW"
  | "CLEAR_GEOFILTER";

export const changeCenter = createStandardAction("CHANGE_CENTER")<
  CenterActionPayload
>();
export const changeZoom = createStandardAction("CHANGE_ZOOM")<number>();
export const changeView = createStandardAction("CHANGE_VIEW")<
  ViewActionPayload
>();
export const clearGeofilter = createStandardAction("CLEAR_GEOFILTER")();

const MapActions = { changeCenter, changeZoom, changeView };
export type MapAction = ActionType<typeof MapActions>;

export type MapViewState = {
  longitude: number;
  latitude: number;
  zoom: number;
  bounds: GeoBox;
  geofilter: boolean;
};

export const defaultMapState: MapViewState = {
  longitude: -15,
  latitude: 49.8,
  zoom: 1.5,
  bounds: {
    bottomRight: {
      lat: -90,
      lon: 180
    },
    topLeft: {
      lat: 90,
      lon: -180
    }
  },
  geofilter: false
};

export const DevicesMapReducer = createReducer(defaultMapState)
  .handleAction(changeCenter, (state, action) => ({
    ...state,
    longitude: action.payload.longitude,
    latitude: action.payload.latitude
  }))
  .handleAction(changeView, (state, action) => ({
    ...state,
    longitude: action.payload.longitude,
    latitude: action.payload.latitude,
    zoom: action.payload.zoom,
    bounds: action.payload.bounds || state.bounds,
    geofilter: true
  }))
  .handleAction(changeZoom, (state, action) => ({
    ...state,
    zoom: action.payload
  }))
  .handleAction(clearGeofilter, state => ({
    ...state,
    geofilter: false
  }));

export type DevicesMapState = StateType<typeof DevicesMapReducer>;
